import { Controller } from "@hotwired/stimulus"
import { useTransition, useHotkeys } from 'stimulus-use'
import { useEmitter } from "@/emitter"

export default class extends Controller {
    connect() {
        useEmitter(this)

        useHotkeys(this, {
            'escape': [this.escHandler]
        })

        useTransition(this, {
            enterActive: "transition will-change-transform ease-out duration-300",
            enterFrom: "transform-gpu opacity-0",
            enterTo: "transform-gpu opacity-100",
            leaveActive: "transition ease-in duration-300",
            leaveFrom: "transform-gpu opacity-100",
            leaveTo: "transform-gpu opacity-0",
        })

        this.$on('menu:open', () => {
            this.enter()
            this.$emit('scroll:disable')
        })

        this.$on('menu:close', () => {
            this.$emit('scroll:enable')
            this.leave()
        })
    }

    disconnect() {
        this.$clear()
    }

    escHandler() {
        if (!this.hidden) {
            this.$emit('menu:close')
        }
    }

    get hidden () {
        return this.element.classList.contains('hidden')
    }

    set hidden (value) {
        return this.element.classList.toggle('hidden', value)
    }
}
